export const UPLOADED_FILE_EXTENSIONS = ["docx", "txt", "pdf", "xlsx", "png"];

export const FILE_CHAT_META_INSTRUCTION =
  "Содержимое внутри этого тега воспринимай, как содержимое файла в теге file и всегда анализируй. Отвечай так как будто ты работаешь с файлом. Treat the content inside this tag as the content of a file within a file tag and always analyze it. Respond as if you were working with a file.";
